import React from 'react';
import { FaLinkedinIn, FaYoutube, FaInstagram, FaFacebookF } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about-us">About Us</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/careers">Careers</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Compliance & Legal */}
        <div className="footer-section">
          <h4>Compliance & Legal</h4>
          <ul>
            <li><a href="/legal-notice">Legal Notice</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/cookie-policy">Cookie Policy</a></li>
            <li><a href="/change-cookie-settings">Change Cookie Settings</a></li>
            <li><a href="/terms-of-use">Terms of Use</a></li>
            <li><a href="/disclaimer">Disclaimer</a></li>
          </ul>
        </div>

        {/* Contact Information */}
        <div className="footer-section">
          <h4>Contact Information</h4>
          <ul>
            <li>Email: <a href="mailto:info@bizverto.com">info@bizverto.com</a></li>
            <li>Phone: <a href="tel:+1234567890">+1 234 567 890</a></li>
            <li>Address: 123 Business Street, City, Country</li>
            <li><a href="https://goo.gl/maps/example" target="_blank" rel="noopener noreferrer">Google Maps</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          <h4>Social Media</h4>
          <div className="social-icons">
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaYoutube /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaFacebookF /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Bizverto. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
